import React from 'react';
import Icon from '../../../components/AppIcon';

const ValueProposition = () => {
  const features = [
    {
      icon: 'FileText',
      title: 'Professional Templates',
      description: 'Access industry-standard credit templates used by major studios and production companies.'
    },
    {
      icon: 'Upload',
      title: 'Excel Import',
      description: 'Upload your existing credit lists from Excel spreadsheets with our smart import tool.'
    },
    {
      icon: 'Video',
      title: 'HD Video Export',
      description: 'Generate high-quality video files in multiple formats ready for final delivery.'
    },
    {
      icon: 'Palette',
      title: 'Custom Formatting',
      description: 'Customize fonts, colors, timing, and layouts to match your project\'s visual style.'
    },
    {
      icon: 'Clock',
      title: 'Fast Rendering',
      description: 'Professional-grade rendering engine delivers your credit sequences in minutes, not hours.'
    },
    {
      icon: 'Shield',
      title: 'Secure & Reliable',
      description: 'Enterprise-level security ensures your project data and credits remain confidential.'
    }
  ];

  return (
    <div className="bg-muted/30 rounded-xl p-6 lg:p-8">
      <div className="text-center mb-8">
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Join Thousands of Filmmakers
        </h3>
        <p className="text-muted-foreground">
          Create professional film credits that meet industry standards
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={20} className="text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Trust Indicators */}
      <div className="mt-8 pt-6 border-t border-border">
        <div className="flex items-center justify-center space-x-6 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={14} />
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Users" size={14} />
            <span>10,000+ Users</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Star" size={14} />
            <span>Industry Approved</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ValueProposition;